
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabandbusserviceinshiajinagar() {



const cardData = {
  keyword: 'Corporate Cab and Bus Services in Shivaji Nagar',
  heading: 'eTravo: Corporate Cab and Bus Services in Shivaji Nagar',
  headingDescription: `eTravo offers premium corporate cab and bus services in Shivaji Nagar, Pune, one of the city’s busiest commercial and administrative hubs. Whether you require transportation for executives, employees, or clients, our well-maintained fleet of air-conditioned, GPS-equipped vehicles ensures seamless travel to and from offices, government buildings, courts, hotels, and educational institutions located in and around Shivaji Nagar.`,

  top: 'Top Places to visit in Pune with eTravo',
  "topPlaces": [
  {
    "title": "Hinjewadi IT Park",
    "description": "Hinjewadi is Pune’s largest IT hub, home to major tech companies like Infosys, Wipro, TCS, and Cognizant. eTravo provides daily employee transportation, shuttle services, and executive cabs to support corporate mobility in this high-traffic zone, ensuring timely shift-based commutes."
  },
  {
    "title": "Magarpatta City SEZ",
    "description": "Magarpatta is a well-planned commercial township that houses numerous corporate offices, especially in the IT and finance sectors. eTravo offers customized transport for employees, clients, and business meetings, making daily operations more efficient and stress-free."
  },
  {
    "title": "Pune Railway Station",
    "description": "A key transit point in the city, Pune Junction connects travelers across Maharashtra and India. eTravo ensures smooth last-mile connectivity with prompt pickup and drop services for commuters, corporate travelers, and tourists alike."
  },
  {
    "title": "Shivajinagar Commercial Area",
    "description": "This central district of Pune is a hub of legal offices, banks, and government institutions. eTravo's executive cab service supports professionals commuting for legal work, government duties, and high-priority business interactions."
  },
  {
    "title": "Pimpri-Chinchwad Industrial Zone",
    "description": "One of India’s major industrial belts, Pimpri-Chinchwad houses companies like Tata Motors, Bajaj Auto, and SKF. eTravo provides reliable transport for factory workers, supervisors, and logistics teams, operating on shift schedules with precision."
  },
  {
    "title": "Kharadi IT and Business Park",
    "description": "Kharadi is a rapidly growing IT corridor with offices of multinational companies such as IBM, EON, and Barclays. eTravo's tech-enabled cab solutions cater to business travelers and daily office commutes with efficiency and safety."
  },
  {
    "title": "Swargate Bus Terminal",
    "description": "Swargate is a major road transport hub linking Pune with cities across Maharashtra. eTravo offers cab services to help passengers travel comfortably to and from Swargate, ensuring they catch their intercity buses on time."
  },
  {
    "title": "Deccan Gymkhana",
    "description": "A vibrant area with a mix of education, entertainment, and shopping. eTravo serves students, shoppers, and professionals in the area with flexible cab services suited for short rides, events, and daily commuting."
  },
  {
    "title": "Pune International Airport (Lohegaon)",
    "description": "The city’s primary air travel hub, connecting Pune with major domestic and international destinations. eTravo provides airport transfers with real-time flight tracking, professional drivers, and 24/7 support for stress-free travel experiences."
  },
  {
    "title": "Symbiosis International University (Lavale Campus)",
    "description": "A renowned academic institution in Pune attracting students from across India and abroad. eTravo ensures safe, regular, and comfortable transportation for students and faculty, particularly to remote campuses like Lavale."
  }
],

services: [
  {
    name: 'Shivaji Nagar Corporate Transport Solutions',
    description: `Comprehensive monthly transport services for corporates in Shivaji Nagar. From executive travel to regular staff commute, we offer punctual, professional transport solutions tailored for business needs.`
  },
  {
    name: 'Office Commute Bus & Cab Hire Shivaji Nagar',
    description: `Monthly office commute packages with buses and cabs available for hire in Shivaji Nagar. Suited for teams of various sizes, offering flexible routing, trained drivers, and on-time performance tracking.`
  },
  {
    name: 'Executive Travel Cab Services Shivaji Nagar',
    description: `Premium executive cab services designed for senior management and visiting professionals. Enjoy a smooth ride in luxury vehicles with courteous chauffeurs and reliable scheduling in Shivaji Nagar.`
  },
  {
    name: 'Daily Shuttle for Companies in Shivaji Nagar',
    description: `Scheduled daily shuttle services for businesses in Shivaji Nagar. Ideal for large groups of employees with fixed routes and consistent shift-time coverage using vans or minibuses.`
  },
  {
    name: 'Reliable Staff Pick & Drop Shivaji Nagar',
    description: `Reliable monthly staff pick-up and drop services for companies in Shivaji Nagar. Features include GPS-enabled vehicles, shift-aligned scheduling, and dedicated drivers ensuring safety and punctuality.`
  },
  {
    name: 'Business Travel Cab and Bus Rentals in Shivaji Nagar',
    description: `Flexible cab and bus rental options for business travel in Shivaji Nagar. Suitable for client visits, field operations, and inter-office movement, with monthly billing and fleet availability.`
  }
],

tableData: [
  ['Shivaji Nagar Corporate Transport Solutions', 'Office Commute Bus & Cab Hire Shivaji Nagar'],
  ['Executive Travel Cab Services Shivaji Nagar', 'Daily Shuttle for Companies in Shivaji Nagar'],
  ['Reliable Staff Pick & Drop Shivaji Nagar', 'Business Travel Cab and Bus Rentals in Shivaji Nagar']
],


"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab and Bus Services in Shivaji Nagar",
    "WhyChoosedescription": "eTravo offers reliable and efficient corporate cab and bus services tailored for businesses in Shivaji Nagar. We ensure timely and comfortable employee commutes suited to your company’s schedules."
  },
  {
    "WhyChooseheading": "Diverse Fleet to Meet All Corporate Travel Needs",
    "WhyChoosedescription": "Select from a wide range of vehicles including sedans, SUVs, and buses to accommodate executive travel as well as large employee groups within Shivaji Nagar."
  },
  {
    "WhyChooseheading": "Customized Shift-Based Transport Solutions",
    "WhyChoosedescription": "Our transport services are designed to align with your business shift timings, ensuring seamless pick-up and drop-off for employees during peak and off-peak hours."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Shivaji Nagar",
    "WhyChoosedescription": "Our drivers are skilled and knowledgeable about Shivaji Nagar’s roads and traffic, guaranteeing safe, punctual, and efficient transportation for your team."
  },
  {
    "WhyChooseheading": "GPS Tracking for Enhanced Security and Monitoring",
    "WhyChoosedescription": "All vehicles are equipped with GPS systems for real-time tracking, providing businesses with full transparency and control over their employee transport."
  },
  {
    "WhyChooseheading": "Transparent Pricing with Detailed Monthly Statements",
    "WhyChoosedescription": "Benefit from clear, itemized monthly billing that helps corporate clients manage budgets and analyze transportation expenses effortlessly."
  },
  {
    "WhyChooseheading": "Committed to Safety and Hygiene Standards",
    "WhyChoosedescription": "We maintain strict hygiene protocols with regular sanitization of vehicles to ensure a safe and clean travel environment for all passengers."
  },
  {
    "WhyChooseheading": "Dedicated Account Management for Smooth Operations",
    "WhyChoosedescription": "Our dedicated support team manages your monthly transport plans, coordinating schedules and resolving any issues to keep your operations running smoothly."
  }
]














}

const faqData = [
  [
    {
      question: "Which areas do your corporate cab and bus services in Pune cover?",
      answer: "We provide corporate cab and bus transportation across Pune, including Shivaji Nagar, Model Colony, JM Road, and nearby business districts."
    },
    {
      question: "Can we customize transport solutions based on our company’s office hours and employee count?",
      answer: "Yes, we offer flexible transport plans tailored to your shift timings, headcount, and specific routing needs using both cabs and buses."
    },
    {
      question: "Are GST-compliant invoices available for corporate transportation services?",
      answer: "Absolutely. Our corporate billing includes monthly GST-compliant invoices and detailed breakdowns of service usage."
    },
    {
      question: "Do your services include trained and uniformed drivers?",
      answer: "Yes, all our drivers are professionally trained, background-verified, and maintain high standards of punctuality and conduct."
    },
    {
      question: "What safety and hygiene protocols are followed in your vehicles?",
      answer: "Our vehicles are sanitized regularly, GPS-enabled, and maintained to top standards. We also enforce regular driver checks and hygiene practices."
    },
    {
      question: "Is coordination support available for managing daily transportation?",
      answer: "Yes, we offer dedicated coordination support and tracking dashboards to streamline employee transport management."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Amit Deshmukh",
    designation: "Admin Manager, Shivaji Nagar Business Center",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s cab and bus service has brought unmatched reliability to our daily employee commute. Highly recommended for office clusters like Shivaji Nagar.”"
  },
  {
    name: "Ms. Rutuja Naik",
    designation: "Operations Lead, EliteTech Solutions",
    rating: [1, 1, 1, 1, 1],
    text: "“Their corporate transport solution in Shivaji Nagar is smooth, safe, and incredibly well-managed. Great experience with their support team.”"
  }
];















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab and Bus Services in Shivaji Nagar",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bus-service-shivaji-nagar.jpg",
  "description": "Book corporate cab and bus services in Shivaji Nagar with eTravo for office commute, executive travel, and daily staff shuttle. Reliable and professional AC vehicles tailored for businesses in Shivaji Nagar.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5657"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2299",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-and-bus-services-in-shivaji-nagar"
  }
};






    return (
        <div>

<Helmet>
  <title>Corporate Cab and Bus Services in Shivaji Nagar | Staff Transport & Office Shuttle | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus services in Shivaji Nagar with eTravo for executive travel, staff pick & drop, and business commute. Affordable and reliable AC cabs and buses for companies in Shivaji Nagar." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/97.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabandbusserviceinshiajinagar;